import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode'; // Type defintitions

import * as TYPES from '../../types';
import { mobileAppUtil } from '../../util';
import { HorizontalMenu } from "./HorizontalMenu"; // JSS

import { Link } from '@sitecore-jss/sitecore-jss-react';
import ducks from "../../ducks";
import { connect } from 'react-redux';
var retail = ducks.retail;
var operations = retail.operations;
var pageChange = operations.pageChange;

var RetailNavComponent = function RetailNavComponent(props) {
  var _document$getElementB, _document$getElementB2, _document$getElementB3;

  var _props$navLinks = props.navLinks,
      navLinks = _props$navLinks === void 0 ? [] : _props$navLinks,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {
    background: "white",
    padding: "small"
  } : _props$layout,
      changeCategory = props.changeCategory,
      currentCategory = props.currentCategory,
      setCurrentPage = props.setCurrentPage;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = useState(currentCategory),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var pathname;

  if (typeof window !== "undefined") {
    pathname = window.location.pathname;
  }

  var setValues = function setValues(value) {
    if (typeof value === 'string' && value !== "") {
      value = JSON.parse(value);
    }

    if (value) {
      var href = value.href;
      setCurrentPage(0);
      window.location.pathname = href;
    }

    return;
  };

  var filtered = navLinks.filter(function (el) {
    // console.log(pathname, el.href,"RETAILNAV")
    return el.href === pathname;
  })[0]; // const paddingTop = (mobileAppUtil.isiOS() && isSticky) ? '40px' : '0px'

  var paddingTop = mobileAppUtil.isiOS() && isSticky ? '0px' : '0px';

  var handleStateChange = function handleStateChange(statusobj) {
    var status = statusobj.status;
    if (mobileAppUtil.isiOS()) if (status == 2 || status == 'STATUS_FIXED') {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  var activeItemChangedCallback = function activeItemChangedCallback(allItems, selectedItemKey, setCurrentPage) {
    var items = allItems === null || allItems === void 0 ? void 0 : allItems.filter(function (x) {
      return x.href == selectedItemKey;
    });

    if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
      var _items$, _items$2;

      setCurrentPage(0);
      setValues((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.href);
      changeCategory((_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.href);
    }
  };

  var navigationLinks = [{
    href: "/shop/categories",
    text: "All",
    title: "All"
  }].concat(navLinks);
  var tempProps = {
    paddingTop: paddingTop,
    navLinks: navigationLinks,
    activeItemChangedCallback: activeItemChangedCallback,
    activeItem: currentCategory || window.location.pathname,
    isRetail: true
  };
  useEffect(function () {// if(filtered?.href){
    //     const activeElement = document.getElementById(`eatNav-mobile-${filtered?.href}`)
    //     window.setTimeout(() => activeElement?.scrollIntoView({behavior: "smooth", block: "center",inline: "nearest"}), 200)
    // }
  }, [filtered === null || filtered === void 0 ? void 0 : filtered.href]);
  var top = ((_document$getElementB = document.getElementById('mobileHeader')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.style) === null || _document$getElementB2 === void 0 ? void 0 : (_document$getElementB3 = _document$getElementB2.height) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.replace('px', '')) || 80;
  return /*#__PURE__*/React.createElement(Sticky, {
    enabled: true,
    top: Number(mobileAppUtil.isMobileApp() ? top : 0),
    innerZ: 2,
    onStateChange: handleStateChange
  }, /*#__PURE__*/React.createElement(HorizontalMenu, _extends({}, tempProps, {
    setCurrentPage: setCurrentPage
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    retail: state.retail
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setCurrentPage: function setCurrentPage(currentPage) {
      return dispatch(pageChange(currentPage));
    }
  };
};

var RetailNav = connect(mapStateToProps, mapDispatchToProps)(RetailNavComponent);
RetailNav.propTypes = {
  navLinks: PropTypes.arrayOf(TYPES.scLinkType)
};
export { RetailNav };